import { post } from '../lib/apiClient';

/**
 * POST /registration — public self-signup. investorType is a DECLARATION
 * only; accredited access additionally requires an approved proof-of-funds
 * review (platform invariant — never gate UI on the declaration alone).
 */
export const register = (payload) => post('/registration', payload, { auth: false });

/**
 * POST /registration/verify-email — { email, token }, both from the emailed link.
 *
 * The email is not redundant. The service stores only a HASH of the token
 * (user.metadata.emailVerification.tokenHash), so it cannot look an account up
 * by the raw token — it fetches by email, then compares. Sending only the token
 * returned "email and token are required" (HTTP 400) for every verification
 * attempt; buildVerificationUrl() has always put both in the link.
 */
export const verifyEmail = (email, token) =>
  post('/registration/verify-email', { email, token }, { auth: false });

/** POST /registration/resend-verification — { email } */
export const resendVerification = (email) =>
  post('/registration/resend-verification', { email }, { auth: false });
